import { type ReactNode } from "react"
import { GridItem, Typography } from "@octopus-energy/coral/atoms"
import DashboardLayoutBreadcrumbs from "./DashboardLayoutBreadcrumbs"

type HeaderProps = {
    title: ReactNode
}

export function DashboardLayoutHeader({ title }: HeaderProps) {
    return (
        <GridItem
            gridArea="header"
            alignSelf="center"
        >
            <Typography
                textStyle="h3"
                component="h1"
            >
                {title}
            </Typography>
            <DashboardLayoutBreadcrumbs />
        </GridItem>
    )
}
